import { Ring } from 'ui/quality-control/board/ring';

import { BoardConfigurationData, RingData } from './types';

type BoardProps = {
  boardConfiguration: BoardConfigurationData;
  rings: RingData[];
  selectedRing?: string | null;
  onSegmentMouseEnter?: (points: string) => void;
  onSegmentMouseLeave?: () => void;
  setSelectedRing?: (ringId: string) => void;
  canManageCompliance?: boolean;
};

export const Board = ({
  boardConfiguration,
  rings,
  selectedRing,
  onSegmentMouseEnter,
  onSegmentMouseLeave,
  setSelectedRing,
  canManageCompliance,
}: BoardProps) => {
  return (
    <>
      {rings.map((ring, index) => (
        <Ring
          key={ring.id}
          data={ring}
          boardConfiguration={boardConfiguration}
          boardPosition={index}
          isHighlighted={selectedRing === ring.id}
          onSegmentMouseEnter={onSegmentMouseEnter}
          onSegmentMouseLeave={onSegmentMouseLeave}
          setSelectedRing={setSelectedRing}
          canManageCompliance={canManageCompliance}
        />
      ))}
    </>
  );
};
